import { Command } from "clipanion";
import { M8tCommand } from "../../lib/m8t-command.js";
import { colors } from "../../lib/output.js";
import { checkArchitectDrift } from "../../lib/architect-version.js";

export class ArchitectCheckCommand extends M8tCommand {
  static paths = [["architect-check"]];
  static usage = Command.Usage({
    description: "Verify the installed m8t-architect persona matches the repo source.",
    details:
      "Compares a render-time content hash (stored in ~/.claude/skills/m8t-architect/.m8t-skill.json) against a fresh hash of <repo-root>/personas/m8t-architect/persona.md. Exits 0 when they match, 1 with remediation advice when they don't. Used as a pre-flight gate by the architect persona body and as a verification step in guides/install/m8t.md.",
    examples: [
      ["Run the architect drift check", "$0 architect-check"],
    ],
  });

  executeCommand(): Promise<number> {
    const r = checkArchitectDrift();
    if (r.match) {
      this.context.stdout.write(`${colors.success("✓")} m8t-architect is in sync${r.sourceVersion ? ` (v${r.sourceVersion})` : ""}.\n`);
      return Promise.resolve(0);
    }
    this.context.stdout.write(
      `${colors.error("✗")} m8t-architect drift detected. Installed v${r.installedVersion || "(missing)"}, source v${r.sourceVersion || "?"}.\n`,
    );
    if (r.advice) this.context.stdout.write(`  ${colors.hint("→")} ${r.advice}\n`);
    return Promise.resolve(1);
  }
}
